import { Close, Save } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import { checkPhone } from "lib/strings";
import { checkUserLog, createUser, updateUser } from "models/usersModel";
import { useSnackbar } from "notistack";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { openLoading } from "store/reducers/tools";
import CustomerForm from "../pages/customers/forms/CustomerForm";

export default function CustomerDialog({
  data = {},
  open = false,
  title = "Edit Customer",
  actionType = "edit",
  onChangePhoneCode = () => {},
  onClose = () => {},
  onEditUser = () => {},
}) {
  const addFormRef = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const authUser = useSelector((state) => state?.auth?.user ?? {});

  const handleSave = () => {
    const submitData = addFormRef.current?.prepare();
    if (!checkPhone(`+${data?.phone_code ?? "64"}${submitData?.phone}`))
      return enqueueSnackbar("Phone number is not valid", {
        variant: "warning",
      });
    if (submitData) {
      openLoading(true);
      if (actionType === "edit") {
        let log = checkUserLog({
          changerName: authUser?.name ?? "",
          newValue: {
            ...submitData,
            user_status: submitData?.status?.id ?? "",
          },
          initial: data,
        });
        const logData = Boolean(log)
          ? {
              log_data: {
                user_id: submitData?.id,
                changer_id: authUser?.id,
                changer_type: "admin",
                log: log,
              },
            }
          : {};
        updateUser({
          data: { phone_code: data?.phone_code ?? "64", ...submitData },
          logData,
          onFinish: (res, err) => {
            openLoading(false);
            if (res === false) {
              if (!res && err?.message) {
                enqueueSnackbar(err?.message, { variant: "warning" });
              } else {
                enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
              }
              return;
            }
            enqueueSnackbar("Successfully Updated in", {
              variant: "success",
            });
            onEditUser(res, logData?.log_data ?? {});
          },
        });
      } else {
        createUser({
          data: {
            ...submitData,
            phone_code: data?.phone_code ?? "64",
            role: submitData?.role?.id ?? "0",
          },
          onFinish: (res, err) => {
            openLoading(false);
            if (res === false) {
              if (!res && err?.message) {
                enqueueSnackbar(err?.message, { variant: "warning" });
              } else {
                enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
              }
              return;
            }
            enqueueSnackbar("Successfully Saved in", { variant: "success" });
            onEditUser(res?.user ?? {});
          },
        });
      }
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth={"sm"}
      // disableBackdropClick
      scroll="paper"
    >
      <DialogTitle className="flex justify-between items-center bg-back">
        {title}
        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent className="w-full scroll-thumb">
        <div className="scroll-scroll-thumb-x">
          <CustomerForm
            ref={addFormRef}
            onChangePhoneCode={onChangePhoneCode}
            data={data}
            actionType={actionType}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2} justifyContent={"flex-end"}>
          <Grid item>
            <Button
              onClick={handleSave}
              variant="contained"
              color="primary"
              startIcon={<Save />}
            >
              Save
            </Button>
          </Grid>
          <Grid item>
            <Button onClick={onClose} variant="outlined" color="primary">
              <CustomText variant="body2" bold={600} color="secondary">
                Close
              </CustomText>
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
